import { computed, watch } from "vue";
import { useHeader } from "../components/master-page/header";
import { ResponsiveUtils } from "@sazka/utils/responsive-utils";
import { useNgCasinoState } from "@sazka/casino/js/core/use-ng-casino-state";

export const useCasinoHeader = () => {
    const { currentGameId } = useNgCasinoState();
    const isMobileOnPageLoad = ResponsiveUtils.isMobile();

    const gameIsOpen = computed(() => currentGameId.value !== 0);
    const { resetHeader, disableHeader, setHeaderState } = useHeader();

    watch(gameIsOpen, () => {
        if (!gameIsOpen.value) {
            resetHeader();
            return;
        }

        if (isMobileOnPageLoad) {
            disableHeader();
        } else {
            setHeaderState({ active: true, transparent: false, animated: false });
        }
    });
};
